import { TranslateService } from '@ngx-translate/core';

export type SnackbarTheme = 'warning' | 'alert' | 'success' | 'information';

/**
 * State of a page-local `lib-snackbar` shown for a few seconds:
 * `snackbar = new TimedSnackbar(translate)`, then `snackbar.show('alert', 'some.translation.key')`, and in the template
 * `*ngIf="snackbar.visible"` / `[theme]="snackbar.theme"` / `[title]="snackbar.text"`.
 */
export class TimedSnackbar {
  visible = false;
  theme: SnackbarTheme = 'success';
  text = '';

  private hideTimer?: ReturnType<typeof setTimeout>;

  constructor(
    private readonly translate: TranslateService,
    private readonly durationMs = 3000,
  ) {}

  /** Shows the translation of `key` (with its `params`) for `durationMs`. */
  show(theme: SnackbarTheme, key: string, params?: Record<string, unknown>): void {
    this.theme = theme;
    this.text = this.translate.instant(key, params);
    this.visible = true;
    clearTimeout(this.hideTimer);
    this.hideTimer = setTimeout(() => (this.visible = false), this.durationMs);
  }
}
